import { FC } from 'react';

import { GridApiPro } from '@mui/x-data-grid-pro';

import DefaultButton from './components/DefaultButton';
import Dropdown from './components/Dropdown';
import Action from './types/action.type';

type ActionButtonProps = {
  action: Action;
  apiRef: React.MutableRefObject<GridApiPro>;
};

const ActionButton: FC<ActionButtonProps> = ({ apiRef, action }) => {
  const renderComponentByType = (action: Action) => {
    switch (action.type) {
      case 'default':
        return <DefaultButton apiRef={apiRef} {...action} />;
      case 'dropdown':
        return <Dropdown apiRef={apiRef} {...action} />;
      case 'custom':
        return action.button;
      default:
        throw new Error('Invalid action type was provided');
    }
  };

  return renderComponentByType(action);
};

export default ActionButton;
